/* Royal Fones V3 — store logic */
(function(){
  'use strict';

  /* ---------- Currency ---------- */
  /* 1 AED in each currency. Approximate fallback; refreshed daily from live rates below. */
  var RATES = {AED:1, USD:0.2723, EUR:0.2347, GBP:0.2025, PKR:76.8, SAR:1.021, QAR:0.991, KWD:0.0834, BHD:0.1026, OMR:0.1047,
    CAD:0.375, AUD:0.415, CHF:0.218, TRY:11.5, INR:23.9, BDT:33.2, MYR:1.15, SGD:0.35, IDR:4450, CNY:1.95, JPY:40.5, KRW:380,
    ZAR:4.85, EGP:13.3, NGN:415, KES:35.2, BRL:1.5, MXN:5.0, AZN:0.463, KZT:140, UZS:3350, AFN:18.7, JOD:0.193, MAD:2.5};
  var cur = localStorage.getItem('rf_cur') || 'AED';
  (function(){
    try {
      var c = JSON.parse(localStorage.getItem('rf_rates') || 'null');
      if(c && c.r){ for(var k in c.r) if(RATES[k]) RATES[k] = c.r[k]; }
      if(c && c.t && Date.now() - c.t < 864e5) return;
      fetch('https://open.er-api.com/v6/latest/AED').then(function(r){ return r.json(); }).then(function(d){
        if(!d || !d.rates) return;
        var keep = {};
        for(var k in RATES){ if(d.rates[k]){ RATES[k] = d.rates[k]; keep[k] = d.rates[k]; } }
        try { localStorage.setItem('rf_rates', JSON.stringify({t: Date.now(), r: keep})); } catch(e){}
        renderPrices(); refreshBag();
      }).catch(function(){});
    } catch(e){}
  })();
  function fmt(aed){
    var c = RATES[cur] ? cur : 'AED', v = aed * RATES[c];
    if(c === 'AED') return 'AED ' + Math.round(v).toLocaleString('en-GB');
    if(c === 'PKR') return 'Rs ' + Math.round(v).toLocaleString('en-GB');
    v = v >= 100000 ? Math.round(v / 1000) * 1000 : Math.round(v);
    try { return new Intl.NumberFormat('en-GB', {style: 'currency', currency: c, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: 0}).format(v); }
    catch(e){ return c + ' ' + v.toLocaleString('en-GB'); }
  }
  /* Pakistan has its own price list (set per variant in Shopify: "Pakistan price (PKR)") */
  var PAGE2PROD = {'v3-product-diamante':'diamante','v3-product-oro':'oro-puro','v3-product-barocco':'barocco','v3-product-himalaya':'himalaya-platino','v3-product-smeraldo':'aquila-smeraldo','v3-product-nero':'nero-coccodrillo','v3-product-rosa':'rosa-cipria','v3-product-moka':'moka','v3-product-verde':'verde-bosco','v3-product-ciliegia':'ciliegia','v3-product-viola':'viola','v3-product-burgundy':'royal-burgundy','v3-product-serpente':'serpente'};
  function prodFor(pageHandle){ return PAGE2PROD[pageHandle] || pageHandle; }
  function pkPrice(el){
    var P = window.rfPK; if(!P || cur !== 'PKR') return 0;
    var vid = el.getAttribute('data-vid-pk');
    if(vid){ if(el.getAttribute('data-pta') === 'PTA approved') return (P.t && P.t[vid]) || -1; return P.v[vid] || 0; }
    if(el.hasAttribute('data-pk-total')) return parseFloat(el.getAttribute('data-pk-total')) || 0;
    var here = location.pathname.split('/pages/')[1] || '';
    if(el.id === 'pdPrice'){
      var b = document.querySelector('[data-add]'), v = b && b.getAttribute('data-vid');
      if(pta === 'PTA approved'){ return (v && P.t && P.t[v]) ? P.t[v] : -1; }
      if(v && P.v[v]) return P.v[v];
      return P.p[prodFor(here)] || 0;
    }
    var a = el.closest ? el.closest('a[href^="/pages/"]') : null;
    if(a) return P.p[prodFor(a.getAttribute('href').slice(7).split(/[?#]/)[0])] || 0;
    return 0;
  }
  function priceText(el, aed){
    var pk = pkPrice(el);
    if(pk < 0) return 'Price on request';
    return pk ? 'Rs ' + Math.round(pk).toLocaleString('en-GB') : fmt(aed);
  }
  /* Pakistan only: PTA approved / non-PTA choice on iPhone pages */
  var pta = '';
  function rs(n){ return 'Rs ' + Math.round(n).toLocaleString('en-GB'); }
  function syncPTA(){
    var opts = document.querySelector('.pd-opts[data-price-for]');
    var add = document.querySelector('[data-add][data-vidmap]');
    var wrap = document.getElementById('rfPTA');
    if(!opts || !add || cur !== 'PKR' || !window.rfPK){ if(wrap) wrap.remove(); pta = ''; return; }
    if(!wrap){
      wrap = document.createElement('div'); wrap.id = 'rfPTA';
      wrap.innerHTML = '<label>PTA STATUS</label><select data-opt="pta"><option value="Non-PTA">Non-PTA</option><option value="PTA approved">PTA approved</option></select>';
      opts.appendChild(wrap);
      var sel = wrap.querySelector('select');
      sel.addEventListener('change', function(){ pta = sel.value; renderPrices(); });
    }
    pta = wrap.querySelector('select').value;
  }
  function relabel(){
    var add = document.querySelector('[data-add][data-vidmap]');
    var map = {}; try { map = JSON.parse(add ? add.getAttribute('data-vidmap') : '{}'); } catch(e){}
    var P = window.rfPK, usePK = cur === 'PKR' && P;
    var mSel = document.querySelector('[data-opt="model"]'), sSel = document.querySelector('[data-opt="storage"]');
    if(!mSel) return;
    var firstS = sSel && sSel.options[0] ? sSel.options[0].value : '';
    function pkOf(m, st){ var v = map[m + '|' + st]; if(!v || !P) return 0; return pta === 'PTA approved' ? ((P.t && P.t[v]) || 0) : (P.v[v] || 0); }
    [].forEach.call(mSel.options, function(o){
      if(!o.hasAttribute('data-l0')) o.setAttribute('data-l0', o.textContent);
      var aed = parseFloat(o.getAttribute('data-aed')) || 0, pk = usePK ? pkOf(o.value, firstS) : 0;
      o.textContent = cur === 'AED' ? o.getAttribute('data-l0') : o.value + (pk ? ' — ' + rs(pk) : (usePK ? '' : (aed ? ' — ' + fmt(aed) : '')));
    });
    if(sSel){
      var m = mSel.value || (mSel.options[0] && mSel.options[0].value);
      [].forEach.call(sSel.options, function(o, i){
        if(!o.hasAttribute('data-l0')) o.setAttribute('data-l0', o.textContent);
        if(cur === 'AED'){ o.textContent = o.getAttribute('data-l0'); return; }
        var diff = 0;
        if(usePK){ var a = pkOf(m, o.value), b = pkOf(m, firstS); diff = (a && b) ? a - b : 0; o.textContent = o.value + (diff > 0 ? ' (+' + rs(diff) + ')' : ''); }
        else { diff = parseFloat(o.getAttribute('data-aed')) || 0; o.textContent = o.value + (diff > 0 ? ' (+' + fmt(diff) + ')' : ''); }
      });
    }
  }
  function renderPrices(){
    syncPTA(); relabel();
    document.querySelectorAll('[data-aed]').forEach(function(el){
      if(el.tagName === 'OPTION') return; /* keep variant labels intact */
      var aed = parseFloat(el.getAttribute('data-aed')) || 0;
      if(aed <= 0){ return; }
      el.textContent = priceText(el, aed);
      /* iOS Safari can leave the old price painted as a ghost when JS swaps
         text inside a transformed (.rv) card — force a clean repaint. */
      void el.offsetWidth;
    });
    document.querySelectorAll('.cur-btn').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-cur') === cur);
    });
  }
  function bindCur(b){
    b.addEventListener('click', function(){
      cur = b.getAttribute('data-cur');
      try { localStorage.setItem('rf_cur', cur); localStorage.setItem('rf_cur_manual', '1'); } catch(e){}
      renderPrices(); refreshBag();
    });
  }
  document.querySelectorAll('.cur-btn').forEach(bindCur);
  /* make sure the visitor's own currency has a button in the header and phone menu */
  function ensureCurBtn(c){
    var groups = [];
    document.querySelectorAll('.cur-btn').forEach(function(b){ if(groups.indexOf(b.parentNode) < 0) groups.push(b.parentNode); });
    groups.forEach(function(g){
      if(g.querySelector('.cur-btn[data-cur="' + c + '"]')) return;
      var all = g.querySelectorAll('.cur-btn'), last = all[all.length - 1];
      var nb = document.createElement('button');
      nb.className = 'cur-btn'; nb.setAttribute('data-cur', c); nb.textContent = c;
      bindCur(nb);
      last.parentNode.insertBefore(nb, last.nextSibling);
    });
  }
  if(cur !== 'AED' && cur !== 'USD') ensureCurBtn(cur);

  /* ---------- Language (EN/AR/UR) ---------- */
  var lang = localStorage.getItem('rf_lang') || 'en';
  function renderLang(){
    document.querySelectorAll('[data-l-en]').forEach(function(el){ el.style.display = 'none'; });
    document.querySelectorAll('[data-l-ar]').forEach(function(el){ el.style.display = 'none'; });
    document.querySelectorAll('[data-l-ur]').forEach(function(el){ el.style.display = 'none'; });
    document.querySelectorAll('[data-l-' + lang + ']').forEach(function(el){ el.style.display = ''; });
    document.documentElement.dir = (lang === 'ar' || lang === 'ur') ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
    document.querySelectorAll('.lang-btn').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-lang') === lang);
    });
  }
  document.querySelectorAll('.lang-btn').forEach(function(b){
    b.addEventListener('click', function(){
      lang = b.getAttribute('data-lang');
      localStorage.setItem('rf_lang', lang);
      renderLang();
    });
  });

  /* ---------- Mobile nav ---------- */
  var burger = document.getElementById('burger');
  var mnav = document.getElementById('mnav');
  if(burger && mnav){
    burger.addEventListener('click', function(){ mnav.classList.toggle('open'); });
    mnav.querySelectorAll('a,button').forEach(function(a){
      a.addEventListener('click', function(){ mnav.classList.remove('open'); });
    });
  }

  /* ---------- Hero slider ---------- */
  var slides = document.querySelectorAll('.hero-slide');
  var dotsWrap = document.querySelector('.hero-dots');
  var cur_slide = 0, timer = null;
  if(slides.length > 1 && dotsWrap && !dotsWrap.children.length){ /* skip when the page runs its own slider */
    slides.forEach(function(_, i){
      var d = document.createElement('button');
      d.setAttribute('aria-label', 'Slide ' + (i+1));
      if(i === 0) d.classList.add('active');
      d.addEventListener('click', function(){ go(i); restart(); });
      dotsWrap.appendChild(d);
    });
    var dots = dotsWrap.querySelectorAll('button');
    var heroSec = document.querySelector('.hero');
    function paintBg(i){
      if(heroSec && slides[i].dataset.bg) heroSec.style.background = slides[i].dataset.bg;
    }
    function go(i){
      slides[cur_slide].classList.remove('active');
      dots[cur_slide].classList.remove('active');
      cur_slide = i;
      slides[cur_slide].classList.add('active');
      dots[cur_slide].classList.add('active');
      paintBg(cur_slide);
    }
    function restart(){ clearInterval(timer); timer = setInterval(function(){ go((cur_slide+1)%slides.length); }, 6000); }
    restart();
  }

  /* ---------- Product options (model/storage -> price) ---------- */
  document.querySelectorAll('[data-price-for]').forEach(function(wrap){
    var modelSel = wrap.querySelector('[data-opt="model"]');
    var storSel = wrap.querySelector('[data-opt="storage"]');
    var priceEl = document.querySelector(wrap.getAttribute('data-price-for'));
    function update(){
      var m = modelSel ? modelSel.selectedOptions[0] : null;
      var s = storSel ? storSel.selectedOptions[0] : null;
      var aed = 0;
      var matrix = null;
      try { matrix = JSON.parse(wrap.getAttribute('data-matrix') || 'null'); } catch(e){}
      if(matrix && m && s){
        var key = m.value + '|' + s.value;
        if(matrix[key]) aed = matrix[key];
      }
      if(!aed){
        if(m) aed += parseFloat(m.getAttribute('data-aed') || 0);
        if(s) aed += parseFloat(s.getAttribute('data-aed') || 0);
      }
      if(priceEl && aed > 0){
        priceEl.setAttribute('data-aed', aed);
        renderPrices();
      }
      // update add-to-bag data
      var addBtn = wrap.parentElement.querySelector('[data-add]');
      if(addBtn){
        var vidmap = {};
        try { vidmap = JSON.parse(addBtn.getAttribute('data-vidmap') || '{}'); } catch(e){}
        var key = (m ? m.value : '') + '|' + (s ? s.value : '');
        if(vidmap[key]) addBtn.setAttribute('data-vid', vidmap[key]);
        renderPrices();
      }
    }
    if(modelSel) modelSel.addEventListener('change', update);
    if(storSel) storSel.addEventListener('change', update);
    update();
  });

  /* ---------- Bag (Shopify cart) ---------- */
  var drawer = document.getElementById('bagDrawer');
  var overlay = document.getElementById('bagOverlay');

  function cartFetch(url, opts){
    return fetch(url, Object.assign({headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}}, opts || {}))
      .then(function(r){ if(!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function refreshBag(){ return cartFetch('/cart.js').then(renderBag).catch(function(){}); }

  function renderBag(cart){
    cart = cart || {items: [], item_count: 0, total_price: 0};
    document.querySelectorAll('.bag-count').forEach(function(el){
      el.textContent = cart.item_count > 0 ? cart.item_count : '';
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    var list = document.getElementById('bagItems');
    var foot = document.getElementById('bagFoot');
    if(!list) return;
    if(!cart.items.length){
      list.innerHTML = '<div class="bag-empty">Your bag is empty.</div>';
      if(foot) foot.style.display = 'none';
      return;
    }
    if(foot) foot.style.display = '';
    list.innerHTML = cart.items.map(function(it){
      return '<div class="bag-item">' +
        '<img src="' + (it.image || 'images/i-logo.png') + '" alt="">' +
        '<div class="bi-info"><h4>' + it.product_title + '</h4>' +
        '<div class="bi-var">' + (it.variant_title || '') + '</div>' +
        ((it.properties && it.properties['PTA status']) ? '<div class="bi-var">' + it.properties['PTA status'] + '</div>' : '') +
        '<div class="bi-price" data-vid-pk="' + it.variant_id + '" data-pta="' + ((it.properties && it.properties['PTA status']) || '') + '" data-aed="' + (it.price/100) + '">' + fmt(it.price/100) + '</div>' +
        '<button class="bi-rm" data-key="' + it.key + '">Remove</button></div></div>';
    }).join('');
    var totalEl = document.getElementById('bagTotal');
    if(totalEl){
      var P = window.rfPK, pkTotal = 0;
      if(P){ cart.items.forEach(function(it){ var ap = it.properties && it.properties['PTA status'] === 'PTA approved'; var p = ap ? (P.t && P.t[it.variant_id]) : P.v[it.variant_id]; pkTotal = (pkTotal >= 0 && p) ? pkTotal + p * it.quantity : -1; }); }
      if(pkTotal > 0) totalEl.setAttribute('data-pk-total', pkTotal); else totalEl.removeAttribute('data-pk-total');
      totalEl.setAttribute('data-aed', cart.total_price/100);
    }
    renderPrices();
    list.querySelectorAll('[data-key]').forEach(function(btn){
      btn.addEventListener('click', function(){
        cartFetch('/cart/change.js', {method: 'POST', body: JSON.stringify({id: btn.getAttribute('data-key'), quantity: 0})})
          .then(refreshBag);
      });
    });
  }

  function openBag(){ if(drawer) drawer.classList.add('open'); if(overlay) overlay.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeBag(){ if(drawer) drawer.classList.remove('open'); if(overlay) overlay.classList.remove('open'); document.body.style.overflow=''; }

  document.querySelectorAll('.bag-btn').forEach(function(b){ b.addEventListener('click', function(){ refreshBag(); openBag(); }); });
  var bagClose = document.getElementById('bagClose');
  if(bagClose) bagClose.addEventListener('click', closeBag);
  if(overlay) overlay.addEventListener('click', closeBag);

  document.querySelectorAll('[data-add]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var vid = btn.getAttribute('data-vid');
      if(!vid){
        var orig0 = btn.getAttribute('data-label') || 'Add to Bag';
        btn.textContent = 'Please choose options';
        setTimeout(function(){ btn.textContent = orig0; }, 1600);
        return;
      }
      btn.disabled = true;
      var item = {id: vid, quantity: 1};
      if(pta) item.properties = {'PTA status': pta};
      cartFetch('/cart/add.js', {method: 'POST', body: JSON.stringify(item)})
        .then(function(){ return refreshBag(); })
        .then(function(){
          var orig = btn.getAttribute('data-label') || 'Add to Bag';
          btn.textContent = 'Added to Bag ✓';
          setTimeout(function(){ btn.textContent = orig; btn.disabled = false; }, 1600);
          openBag();
        })
        .catch(function(){
          btn.textContent = 'Could not add — try again';
          setTimeout(function(){ btn.textContent = btn.getAttribute('data-label') || 'Add to Bag'; btn.disabled = false; }, 1600);
        });
    });
  });

  refreshBag();

  /* (bag checkout now goes to checkout.html) */
  var WA = '923150151831';
  document.querySelectorAll('[data-wa]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var msg = btn.getAttribute('data-wa') || 'Hello Royalfones, I would like to enquire.';
      window.open('https://wa.me/' + WA + '?text=' + encodeURIComponent(msg), '_blank');
    });
  });

  /* Pre-order + Request Invoice: build message from current selections */
  function pdInfo(btn){
    var product = btn.getAttribute('data-product') || 'this piece';
    var wrap = btn.closest('.pd-actions');
    var sec = btn.closest('section') || document;
    var model = '', storage = '', price = '';
    var mSel = sec.querySelector('[data-opt="model"]');
    var sSel = sec.querySelector('[data-opt="storage"]');
    if(mSel && mSel.selectedOptions[0]) model = mSel.selectedOptions[0].value;
    if(sSel && sSel.selectedOptions[0]) storage = sSel.selectedOptions[0].value;
    var pEl = sec.querySelector('#pdPrice') || sec.querySelector('[data-aed]');
    if(pEl) price = pEl.textContent.trim();
    var cur = 'AED';
    try { cur = localStorage.getItem('rf_cur') || 'AED'; } catch(e){}
    return {product: product, model: model, storage: storage, price: price, cur: cur};
  }
  document.querySelectorAll('[data-preorder]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var i = pdInfo(btn);
      var msg = 'Hello Royalfones, I would like to pre-order the ' + i.product;
      if(i.model) msg += ' (' + i.model + (i.storage ? ' ' + i.storage : '') + (pta ? ', ' + pta : '') + ')';
      if(i.price) msg += ' — ' + i.price;
      msg += '.';
      window.open('https://wa.me/' + WA + '?text=' + encodeURIComponent(msg), '_blank');
    });
  });
  document.querySelectorAll('[data-invoice]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var i = pdInfo(btn);
      var msg = 'Hello Royalfones, please send me an invoice for the ' + i.product;
      if(i.model) msg += ' (' + i.model + (i.storage ? ' ' + i.storage : '') + ')';
      if(i.price) msg += ' — ' + i.price;
      msg += '.';
      window.open('https://wa.me/' + WA + '?text=' + encodeURIComponent(msg), '_blank');
    });
  });

  /* ---------- Location + currency (first visit, Vertu-style) ---------- */
  var COUNTRY_CUR = {
    'Pakistan': 'PKR', 'United Arab Emirates': 'AED',
    'Saudi Arabia': 'SAR', 'Qatar': 'QAR', 'Kuwait': 'KWD', 'Bahrain': 'BHD', 'Oman': 'OMR',
    'United Kingdom': 'GBP', 'United States': 'USD', 'Canada': 'CAD', 'Australia': 'AUD',
    'Germany': 'EUR', 'France': 'EUR', 'Italy': 'EUR', 'Spain': 'EUR', 'Netherlands': 'EUR', 'Belgium': 'EUR',
    'Austria': 'EUR', 'Ireland': 'EUR', 'Portugal': 'EUR', 'Greece': 'EUR', 'Switzerland': 'CHF',
    'Turkey': 'TRY', 'India': 'INR', 'Bangladesh': 'BDT', 'Malaysia': 'MYR', 'Singapore': 'SGD', 'Indonesia': 'IDR',
    'China': 'CNY', 'Japan': 'JPY', 'South Korea': 'KRW', 'South Africa': 'ZAR', 'Egypt': 'EGP', 'Nigeria': 'NGN',
    'Kenya': 'KES', 'Brazil': 'BRL', 'Mexico': 'MXN', 'Azerbaijan': 'AZN', 'Kazakhstan': 'KZT', 'Uzbekistan': 'UZS',
    'Afghanistan': 'AFN', 'Jordan': 'JOD', 'Lebanon': 'USD', 'Morocco': 'MAD'
  };
  function setCur(c){
    cur = c;
    try { localStorage.setItem('rf_cur', c); } catch(e){}
    renderPrices();
    refreshBag();
  }
  /* First visit: country pop-up, pre-filled with the visitor's detected country and currency */
  (function(){
    var done = null, manual = null;
    try { done = localStorage.getItem('rf_loc_done'); manual = localStorage.getItem('rf_cur_manual'); } catch(e){}
    var ov = document.getElementById('locOverlay');
    var sel = document.getElementById('locCountry');
    var curSel = document.getElementById('locCurrency');
    var btn = document.getElementById('locContinue');
    function curFor(name){ return COUNTRY_CUR[name] || 'USD'; }
    if(curSel){
      var have = {}, dn = null;
      [].forEach.call(curSel.options, function(o){ have[o.value] = 1; });
      try { dn = new Intl.DisplayNames(['en'], {type: 'currency'}); } catch(e){}
      Object.keys(RATES).forEach(function(c){
        if(have[c]) return;
        var o = document.createElement('option'); o.value = c; o.textContent = c + ' — ' + (dn ? dn.of(c) : c);
        curSel.appendChild(o);
      });
    }
    function detect(cb){
      function viaIp(){ fetch('https://ipapi.co/json/').then(function(r){ return r.json(); }).then(function(d){ cb(d && d.country_name); }).catch(function(){ cb(null); }); }
      try {
        fetch('/browsing_context_suggestions.json', {headers: {'Accept': 'application/json'}})
          .then(function(r){ return r.json(); })
          .then(function(d){ var v = d && d.detected_values; var n = v && (v.country_name || (v.country && v.country.name)); if(n) cb(n); else viaIp(); })
          .catch(viaIp);
      } catch(e){ viaIp(); }
    }
    if(done || !ov || !sel){
      /* no pop-up on this page or already answered: keep the currency in step with the visitor's country */
      if(manual || done) return;
      detect(function(n){ if(!n) return; try { localStorage.setItem('rf_country', n); } catch(e){} var c = curFor(n); ensureCurBtn(c); if(c !== cur) setCur(c); });
      return;
    }
    if(curSel) curSel.value = cur;
    sel.addEventListener('change', function(){ if(curSel && sel.value) curSel.value = curFor(sel.value); });
    ov.classList.add('open');
    document.body.style.overflow = 'hidden';
    detect(function(n){
      if(!n) return;
      if(!sel.querySelector('option[value="' + n + '"]')){ var o = document.createElement('option'); o.value = n; o.textContent = n; sel.insertBefore(o, sel.lastElementChild); }
      if(!sel.value){ sel.value = n; if(curSel) curSel.value = curFor(n); }
    });
    if(btn) btn.addEventListener('click', function(){
      if(!sel.value){ sel.focus(); return; }
      var c = (curSel && curSel.value) || curFor(sel.value);
      try { localStorage.setItem('rf_country', sel.value); localStorage.setItem('rf_loc_done', '1'); localStorage.setItem('rf_cur_manual', '1'); } catch(e){}
      ensureCurBtn(c);
      setCur(c);
      ov.classList.remove('open');
      document.body.style.overflow = '';
    });
  })();

  /* ---------- Checkout page ---------- */
  var coForm = document.getElementById('coForm');
  if(coForm && typeof bag !== 'undefined'){ /* legacy page; orders now go through the bag + Shopify checkout */
    var coItems = document.getElementById('coItems');
    var coTotal = document.getElementById('coTotal');
    var coCountry = document.getElementById('coCountry');
    var coPay = document.getElementById('coPay');
    var bankBox = document.getElementById('bankBox');
    var coErr = document.getElementById('coErr');
    var payMethod = 'WhatsApp concierge';

    function coRenderSummary(){
      if(bag.length === 0){
        coItems.innerHTML = '<div class="bag-empty">Your bag is empty.</div>';
        coTotal.textContent = fmt(0);
        return;
      }
      coItems.innerHTML = bag.map(function(it){
        return '<div class="co-item"><img src="' + it.img + '" alt="">' +
          '<div><h4>' + it.name + '</h4><div class="bi-var">' + (it.variant || '') + '</div></div>' +
          '<div class="co-p">' + fmt(parseFloat(it.price) || 0) + '</div></div>';
      }).join('');
      coTotal.textContent = fmt(bagTotal());
    }

    function coRenderPay(){
      var c = coCountry.value;
      if(c === 'Pakistan'){
        coPay.innerHTML =
          '<label class="pay-opt"><input type="radio" name="pay" value="Bank transfer" checked>' +
          '<span><b>Bank transfer</b><small>Pay to our Pakistani bank account — details below.</small></span></label>' +
          '<label class="pay-opt"><input type="radio" name="pay" value="WhatsApp concierge">' +
          '<span><b>WhatsApp concierge</b><small>Arrange payment personally with our team.</small></span></label>';
        payMethod = 'Bank transfer';
      } else {
        coPay.innerHTML = '<div class="pay-info"><b>WhatsApp concierge</b>' +
          '<small>Our concierge will arrange payment with you personally on WhatsApp.</small></div>';
        payMethod = 'WhatsApp concierge';
      }
      coPay.querySelectorAll('input[name="pay"]').forEach(function(r){
        r.addEventListener('change', function(){
          payMethod = r.value;
          bankBox.hidden = (payMethod !== 'Bank transfer');
        });
      });
      bankBox.hidden = (payMethod !== 'Bank transfer');
    }

    try {
      var sc = localStorage.getItem('rf_country');
      if(sc && coCountry.querySelector('option[value="' + sc + '"]')) coCountry.value = sc;
    } catch(e){}
    coCountry.addEventListener('change', function(){
      try { localStorage.setItem('rf_country', coCountry.value); } catch(e){}
      coRenderPay();
    });

    coRenderSummary();
    coRenderPay();

    coForm.addEventListener('submit', function(e){
      e.preventDefault();
      var name = document.getElementById('coName').value.trim();
      var phone = document.getElementById('coPhone').value.trim();
      var email = document.getElementById('coEmail').value.trim();
      var country = coCountry.value;
      var city = document.getElementById('coCity').value.trim();
      var addr = document.getElementById('coAddr').value.trim();
      var notes = document.getElementById('coNotes').value.trim();
      if(bag.length === 0 || !name || !phone || !country || !city || !addr){
        coErr.textContent = bag.length === 0
          ? 'Your bag is empty.'
          : 'Please fill in your name, WhatsApp number, country, city and address.';
        coErr.hidden = false;
        return;
      }
      coErr.hidden = true;
      var lines = bag.map(function(it, i){
        return (i+1) + '. ' + it.name + (it.variant ? ' — ' + it.variant : '') +
               ' — ' + fmt(parseFloat(it.price) || 0);
      });
      var msg = 'New order — Royal Fones\n\n' + lines.join('\n') +
        '\n\nTotal: ' + fmt(bagTotal()) +
        '\n\nName: ' + name + '\nWhatsApp: ' + phone +
        (email ? '\nEmail: ' + email : '') +
        '\nCountry: ' + country + '\nCity: ' + city + '\nAddress: ' + addr +
        (notes ? '\nNotes: ' + notes : '') +
        '\nPayment: ' + payMethod;
      window.open('https://wa.me/' + WA + '?text=' + encodeURIComponent(msg), '_blank');
      bag = []; saveBag(); renderBag();
      document.getElementById('coWrap').hidden = true;
      document.getElementById('coSuccess').hidden = false;
      document.getElementById('coThanksName').textContent = ', ' + name.split(' ')[0];
      window.scrollTo(0, 0);
    });
  }

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('.pd-thumbs').forEach(function(th){
    var main = th.parentElement.querySelector('.pd-main img');
    if(!main) return;
    th.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        main.src = b.getAttribute('data-src');
        th.querySelectorAll('button').forEach(function(x){ x.classList.remove('on'); });
        b.classList.add('on');
      });
    });
  });

  /* ---------- Reveal on scroll ---------- */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, {threshold:.1});
  document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });

  /* ---------- Drag-to-scroll product rows ---------- */
  document.querySelectorAll('.prod-grid').forEach(function(row){
    if(getComputedStyle(row).overflowX === 'visible') return;
    var down = false, sx = 0, sl = 0, moved = 0;
    row.addEventListener('pointerdown', function(e){
      if(e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = 0; sx = e.clientX; sl = row.scrollLeft;
      row.classList.add('dragging');
    });
    window.addEventListener('pointermove', function(e){
      if(!down) return;
      var dx = e.clientX - sx;
      if(Math.abs(dx) > 4) moved = Math.max(moved, Math.abs(dx));
      row.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function(){
      down = false; row.classList.remove('dragging');
    });
    row.addEventListener('click', function(e){
      if(moved > 6){ e.preventDefault(); e.stopPropagation(); moved = 0; }
    }, true);
  });

  /* ---------- Init ---------- */
  renderPrices();
  renderLang();
  renderBag();
})();
